import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaSave, FaTimes, FaUser } from 'react-icons/fa';
import { sociosAPI } from '../../services/api';
import { toast } from 'react-toastify';
import InputMask from 'react-input-mask';
import './Socios.css';

const SocioForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    titulo: '',
    emissao: null,
    nome: '',
    rg: '',
    cpf: '',
    data_nascimento: null,
    sexo: 'masculino',
    titulo_eleitor: '',
    zona: '',
    secao: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    cep: '',
    telefone: '',
    celular: '',
    email: '',
    status: 'ativo',
    quite: 'nao',
  });

  useEffect(() => {
    if (isEdit) {
      loadSocio();
    }
  }, [id]);

  const loadSocio = async () => {
    try {
      setLoading(true);
      const { data } = await sociosAPI.getById(id);
      
      // Format dates for input
      const socio = data.data;
      if (socio.emissao) {
        socio.emissao = socio.emissao.split('T')[0];
      }
      if (socio.data_nascimento) {
        socio.data_nascimento = socio.data_nascimento.split('T')[0];
      }
      
      setFormData(socio);
    } catch (error) {
      toast.error('Erro ao carregar dados do sócio');
      navigate('/socios');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nome || !formData.titulo) {
      toast.error('Nome e Título são obrigatórios');
      return;
    }

    try {
      setLoading(true);
      
      if (isEdit) {
        await sociosAPI.update(id, formData);
        toast.success('Sócio atualizado com sucesso!');
      } else {
        await sociosAPI.create(formData);
        toast.success('Sócio cadastrado com sucesso!');
      }
      
      navigate('/socios');
    } catch (error) {
      const message = error.response?.data?.message || 'Erro ao salvar sócio';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="socios-container">
      <div className="page-header">
        <div>
          <h1><FaUser /> {isEdit ? 'Editar Sócio' : 'Novo Sócio'}</h1>
          <p>Preencha os dados do sócio</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="socio-form">
        {/* Dados Cadastrais */}
        <div className="form-section">
          <h3>Dados Cadastrais</h3>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="titulo">Título *</label>
              <InputMask
                mask="9999-a"
                id="titulo"
                name="titulo"
                value={formData.titulo}
                onChange={handleChange}
                placeholder="0000-A"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="emissao">Data de Emissão</label>
              <input
                type="date"
                id="emissao"
                name="emissao"
                value={formData.emissao}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="A">Ativo</option>
                <option value="I">Inativo</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="quite">Situação</label>
              <select
                id="quite"
                name="quite"
                value={formData.quite}
                onChange={handleChange}
              >
                <option value="S">Quite</option>
                <option value="N">Não Quite</option>
              </select>
            </div>
          </div>
        </div>

        {/* Dados Pessoais */}
        <div className="form-section">
          <h3>Dados Pessoais</h3>
          <div className="form-row">
            <div className="form-group full-width">
              <label htmlFor="nome">Nome Completo *</label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                placeholder="Digite o nome completo"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="rg">RG</label>
              <input
                type="text"
                id="rg"
                name="rg"
                value={formData.rg}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="cpf">CPF</label>
              <InputMask
                mask="999.999.999-99"
                id="cpf"
                name="cpf"
                value={formData.cpf}
                onChange={handleChange}
                placeholder="000.000.000-00"
              />
            </div>

            <div className="form-group">
              <label htmlFor="data_nascimento">Data de Nascimento</label>
              <input
                type="date"
                id="data_nascimento"
                name="data_nascimento"
                value={formData.data_nascimento}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="sexo">Sexo</label>
              <select
                id="sexo"
                name="sexo"
                value={formData.sexo}
                onChange={handleChange}
              >
                <option value="masculino">Masculino</option>
                <option value="feminino">Feminino</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="titulo_eleitor">Título de Eleitor</label>
              <input
                type="text"
                id="titulo_eleitor"
                name="titulo_eleitor"
                value={formData.titulo_eleitor}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="zona">Zona</label>
              <input
                type="text"
                id="zona"
                name="zona"
                value={formData.zona}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="secao">Seção</label>
              <input
                type="text"
                id="secao"
                name="secao"
                value={formData.secao}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {/* Endereço */}
        <div className="form-section">
          <h3>Endereço</h3>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="cep">CEP</label>
              <InputMask
                mask="99999-999"
                id="cep"
                name="cep"
                value={formData.cep}
                onChange={handleChange}
                placeholder="00000-000"
              />
            </div>

            <div className="form-group flex-2">
              <label htmlFor="endereco">Endereço</label>
              <input
                type="text"
                id="endereco"
                name="endereco"
                value={formData.endereco}
                onChange={handleChange}
                placeholder="Rua, Avenida..."
              />
            </div>

            <div className="form-group">
              <label htmlFor="numero">Número</label>
              <input
                type="text"
                id="numero"
                name="numero"
                value={formData.numero}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="complemento">Complemento</label>
              <input
                type="text"
                id="complemento"
                name="complemento"
                value={formData.complemento}
                onChange={handleChange}
                placeholder="Apto, Bloco..."
              />
            </div>

            <div className="form-group">
              <label htmlFor="bairro">Bairro</label>
              <input
                type="text"
                id="bairro"
                name="bairro"
                value={formData.bairro}
                onChange={handleChange}
              />
            </div>

            <div className="form-group flex-2">
              <label htmlFor="cidade">Cidade</label>
              <input
                type="text"
                id="cidade"
                name="cidade"
                value={formData.cidade}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="estado">Estado</label>
              <input
                type="text"
                id="estado"
                name="estado"
                value={formData.estado}
                onChange={handleChange}
                placeholder="UF"
                maxLength="2"
              />
            </div>
          </div>
        </div>

        {/* Contato */}
        <div className="form-section">
          <h3>Contato</h3>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="telefone">Telefone</label>
              <InputMask
                mask="(99) 9999-9999"
                id="telefone"
                name="telefone"
                value={formData.telefone}
                onChange={handleChange}
                placeholder="(00) 0000-0000"
              />
            </div>

            <div className="form-group">
              <label htmlFor="celular">Celular</label>
              <InputMask
                mask="(99) 99999-9999"
                id="celular"
                name="celular"
                value={formData.celular}
                onChange={handleChange}
                placeholder="(00) 00000-0000"
              />
            </div>

            <div className="form-group flex-2">
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="email@exemplo.com"
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate('/socios')}
            className="btn btn-secondary"
            disabled={loading}
          >
            <FaTimes /> Cancelar
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            <FaSave /> {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SocioForm;
